import React, { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import { Modal } from 'react-responsive-modal';
import { Close } from '@material-ui/icons';
import cc from 'classnames';
import { AuthContext } from '@ryanar/react-auth-provider';
import { IModalProps } from '../IModalProps';

import 'react-responsive-modal/styles.css';
import styles from './ModalWindow.module.css';

const renderHeader = (title: IModalProps['title'], onClose: IModalProps['onClose']) => (
  <div className={styles.header} style={!title ? { marginBottom: '-40px', border: 'none' } : {}}>
    <h3 className={styles.title}>{title}</h3>
    <Button
      color="primary"
      size="small"
      endIcon={<Close className={styles.closeIcon} />}
      className={styles.closeBtn}
      onClick={onClose}
    >
      Close
    </Button>
  </div>
);

const ModalWindow: FC<IModalProps> = ({
  title,
  children,
  onClose,
  className,
  open,
  fullScreen,
  showClose,
  showCloseIcon,
  large,
}) => {
  const { authenticated } = React.useContext(AuthContext);
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const mobileFullScreen = smallScreen && fullScreen;

  const fullScreenStyles: Record<string, CSSProperties> = {
    root: {
      top: authenticated ? '52px' : '81px',
    },
    overlay: {
      top: authenticated ? '52px' : '81px',
      backgroundColor: authenticated ? '#EDEDF2' : '#FFFFFF',
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    modal: {
      position: 'initial',
      margin: '12px',
      padding: 0,
      flexGrow: 1,
      borderRadius: '4px',
      boxShadow: 'none',
      overflowY: 'initial',
    },
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnOverlayClick={false}
      center={!smallScreen}
      classNames={{
        modal: cc(styles.container, { [styles.large]: large }, className),
      }}
      styles={mobileFullScreen ? fullScreenStyles : undefined}
      showCloseIcon={showCloseIcon != null ? showCloseIcon : !smallScreen}
      closeIcon={<Close className={styles.closeIcon} />}
    >
      {(title || showClose) && smallScreen && renderHeader(title, onClose)}
      <div className={cc(styles.content, { [styles.contentFullScreen]: mobileFullScreen })}>
        {title && !smallScreen && <h3 className={styles.title}>{title}</h3>}
        {children}
      </div>
    </Modal>
  );
};

export default ModalWindow;
